<template>
<div>
    <div class="container-fluid featured-image-contact">
        <div class="feature-header-page">
            <h1>Contact Us</h1>
        </div>
    </div>
    <div class="container">
        <div class="row contact-us">
            <div class="offset-xl-2 col-xl-8 col-lg-12 contact-section">
                <h2>Contact Us Today</h2>
                <hr>
                <div class="row contacts">
                    <div class="col-sm-3 contact-us-labels">
                        <p><strong>Tel:</strong></p>
                        <p><strong>Email:</strong></p>
                    </div>
                    <div class="col-sm-9 contact-us-links">
                        <p><a href="tel:07950189260">07950 189 260</a></p>
                        <p><a href="mailto:enquiries@harling-taxis.co.uk">enquiries@harling-taxis.co.uk</a></p>
                    </div>
                </div>
                <p>Fill out our simple online form or contact us via phone or email to discuss how we can help you with all your transporting needs.</p>
               <netlify-form name="contact-form">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="first-name">First name</label>
                            <input name="firstName" id="first-name" class="form-control" type="text" placeholder="First name" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="last-name">Last name</label>
                            <input name="lastName" id="last-name" class="form-control" type="text" placeholder="Last name" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="email-name">Email</label>
                            <input name="email" id="email-name" class="form-control" type="text" placeholder="Your email" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">Phone</label>
                            <input name="phone" id="phone" class="form-control" type="tel" placeholder="Your phone" required>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="message">Your message</label>
                            <textarea name="message" id="message" class="form-control" placeholder="Your message" required></textarea>
                        </div>
                        <div class="form-group col-md-12">
                            <label>GDPR Agreement</label>
                            <div class="row">
                                <div class="col-sm-1 checkbox">
                                    <input type="checkbox" required name="checkbox">
                                </div>
                                <div class="col-sm-11 check-label">
                                    <label>I consent to having this website store my submitted information so they can respond to my enquiry.</label>
                                </div>
                            </div>
                            <button type="submit" class="form-button col-sm-12">Submit</button>
                        </div>
                    </div>
               </netlify-form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NetlifyForm from '@/components/forms/NetlifyForm'

export default {
  name: 'contact-us',
  components: {
    NetlifyForm
  },
  data () {
    return {
      markers: {
        lat: 52.5268689,
        lng: 1.049643
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue